import React, { Component } from 'react';
import { Row, Col, Button, InputGroup, InputGroupAddon, InputGroupText, Input, Label } from 'reactstrap';
import { parseNumber, formatNumber, getCountryCallingCode } from 'libphonenumber-js';
import { isValidNumber, getNumberType } from 'libphonenumber-js/custom';
import metadata from 'libphonenumber-js/metadata.full.json';

import { convertStringToBoolean } from "../../../../utils/CommonUtils";
import i18n from '../../../../i18next';
import MaterialIcon from 'material-icons-react';
import { ARABIC, FRONT_END_URL } from '../../../../utils/Constants';
import phoneIconSrc from '../../../../images/icons/icon-phone-grey.png';
import TickSVG from '../../common/svgComponents/TickSVG';
export default class UserCredentialsCommon extends Component {

    constructor(props) {
        super(props);

        this.state = {
            customerName: '',
            customerEmail: '',
            newsletter: false,
            stateAlreadyCopiedFromProps: false,
            countryCallingCode: null,
            phone: null,
            isPhoneTyped: false,
            countryCodeCoppiedToPhoneInput: false,
            captchaCode: '',
            isSpecialSymbols: false
        };

        this.changeState = this.changeState.bind(this);
    }

    componentDidMount() {
        let countryCallingCode = this.props.brand.countryCode;
        
        if (countryCallingCode) {
            countryCallingCode = getCountryCallingCode(this.props.brand.countryCode);

            this.setState({
                countryCallingCode: countryCallingCode
            });
        }
    }

    reloadCaptcha() {
        this.setState({
            captchaCode: ''
        }, () => {
            this.props.loadCaptcha()
        })

    }

    registerCustomer(state) {
        this.props.registerCustomer(state, this.props.customer, this.props.isPWA, this.props.brand, () => this.reloadCaptcha() );
    }

    openPrivacyPolicyPage() {
        let termsAndConditionsPage = window.open('https://menuu.com/privacy-policy', '_blank');
        termsAndConditionsPage.focus();
    }

    changeState({ target }) {
        let targetValue = target.value;
        if (target.name == 'newsletter') {
            targetValue = convertStringToBoolean(target.value);

            this.setState({
                [target.name]: !targetValue
            });
        } else if (target.name === 'customerEmail') {
            targetValue = targetValue.trim();

            this.setState({
                [target.name]: targetValue
            });
        } else if (target.name === 'customerName' && target.value !== null && target.value !== "" && target.value !== undefined) {
            let regex = /[!a-zA-ZÀ-úА-яЁё\u0620-\u064Aa0-9_.-\s]+/g;

            let nameValue = target.value;
            let isNameInValidFormat = nameValue.match(regex);
            let isSpecialSymbols = nameValue.split(regex).join("");
            const verifiedNameInput = isNameInValidFormat && isNameInValidFormat !== null ? isNameInValidFormat.join("") : '';
            
            if(isSpecialSymbols) {
                this.setState({
                    customerName: verifiedNameInput.trimStart(),
                    isSpecialSymbols: true
                })
            } else {
                this.setState({
                    customerName: verifiedNameInput.trimStart(),
                    isSpecialSymbols: false
                });
            }
        } else {
            this.setState({
                [target.name]: target.value
            },
                () => {

                    let phoneVariable = !this.state.phone && this.state.phone !== 0 ? '' : this.state.phone; // Needed because parseNumber demands a string
                    let phoneNumber = null;
                    let phoneNumbers = [parseNumber(`+${this.state.countryCallingCode}${phoneVariable}`), parseNumber(`${phoneVariable}`), parseNumber(`+${phoneVariable}`), parseNumber(`${phoneVariable}`, this.props.brand.countryCode)];

                    for (let i = 0; i < phoneNumbers.length; i++) {
                        let num = phoneNumbers[i];

                        if (Object.keys(num).length !== 0) {
                            const formatNumberToInternational = formatNumber(num, 'International');
                            const validatedNumber = isValidNumber(formatNumberToInternational, metadata);
                            const isMobileNumber = getNumberType(formatNumberToInternational, metadata);
                            if (validatedNumber && isMobileNumber.includes("MOBILE")) {
                                phoneNumber = num;
                                break;
                            }
                        }
                    }

                    if (!phoneNumber) { // Checks if phoneNumber is too long and exits the function
                        this.setState({
                            submitBtnDisabled: true,
                            isPhoneTyped: false
                        });
                        return;
                    } else {
                        this.setState({
                            submitBtnDisabled: false,
                            isPhoneTyped: true
                        })
                    }
                });
        }
        
        if (this.props.customer.phoneNumberErrMsg) {
            this.props.resetErrMsg()
        }
    }

    renderContent() {
        const { subHeading, inputGroup, inputGroupTickbox, inputGroupText, input, label, marginAuto, privacyPolicy, phoneIconStyle, phoneIconStyleRTL, checkIconStyle, checkIconStyleRTL, termsAndConditions, subMsg } = this.props.styles;
        const { primaryColor, textDecoration, primaryFontColor, menuItemsBackground, fontFamilyType, fontBold, fontItalic, uppercase, type, secondaryColor, inputsFontColor } = this.props.customerThemes.selectedTheme;
        const { isPWA } = this.props;

        // const isCustomerAlreadyLoggedIn = (this.props.customer.email !== undefined && this.props.customer.email !== null) ? true : false;
        const isArabic = this.props.language === ARABIC;
        let isHidden = (this.state.isPhoneTyped) ? false : true;

        const fontWeight = fontBold === 'bold' ? fontBold : 300;
        const titleStyle = {
            margin: isPWA ? '20px auto 5px' : 'auto',
            textAlign: 'center',
            fontSize: 22,
            color: primaryFontColor,
            fontWeight,
            fontFamily: fontFamilyType,
            fontStyle: fontItalic,
            textTransform: uppercase
        }

        const countryCallingCodeStyle = {
            width: 55, 
            maxWidth: 55, 
            borderRadius: 0, 
            borderRightWidth: 0, 
            textAlign: 'start', 
            paddingLeft: 16, 
            color: inputsFontColor 
        }
        const countryCallingCodeStyleRTL = {
            width: 55, 
            maxWidth: 55, 
            borderRadius: 0, 
            borderLeftWidth: 0, 
            textAlign: 'start', 
            paddingRight: 16, 
            color: inputsFontColor 
        }

        return (
            <div className='modal-body-custom'>
                <Col sm={12} className='modal-custom-body-title' style={{ flexDirection: 'column', height: 'auto', maxHeight: 'unset' }}>
                    <p className='title-style' style={titleStyle}>{i18n.t('screens:userCredentialsScreen.heading')}</p>
                    <p style={{...subHeading, paddingBottom: '0px'}}>{i18n.t('screens:userCredentialsScreen.subHeading')}</p>
                    <p style={subHeading}>{i18n.t('screens:userCredentialsScreen.subHeadingTwo')}</p>
                </Col>
                <Col xs={12} md={10} style={{ margin: '10px auto 0', flexDirection: 'column', justifyContent: 'center', flex: 1 }} className='modal-custom-body-inner-content'>
                    <Col xs={12} style={marginAuto}>
                        <div style={{ marginBottom: '10px'}}>
                            <InputGroup style={{ ...inputGroup, ...{ marginBottom: 3 } }}>
                                <div style={{ position: 'absolute', zIndex: 4, padding: '13px 8px', pointerEvents: 'none', color: inputsFontColor }}>+</div>
                                <Input
                                    id='countryCallingCode'
                                    name='countryCallingCode' type='text' autoComplete='none'
                                    autoFocus
                                    onFocus={e => e.currentTarget.select()}
                                    style={ isArabic ? { ...input, ...countryCallingCodeStyleRTL} : { ...input, ...countryCallingCodeStyle}}
                                    // onChange={(e) => this.setState({ ...this.state, countryCallingCode: e.target.value })}
                                    onChange={this.changeState}
                                    value={`${this.state.countryCallingCode}`} />
                                <img src={phoneIconSrc} width="30" height="auto" style={isArabic ? phoneIconStyleRTL : phoneIconStyle} alt='' />
                                <Input
                                    id="phone" type="text"
                                    name="phone"
                                    placeholder='123456789'
                                    onFocus={(e) => e.target.placeholder = ''}
                                    onBlur={(e) => e.target.placeholder = '123456789'}
                                    value={this.state.phone}
                                    onChange={this.changeState}
                                    style={input}
                                    className='addressInputs'
                                />
                                <InputGroupAddon addonType="append">
                                    <TickSVG
                                        width={30} height={30}
                                        fill={type === 'DARK' ? secondaryColor : primaryColor}
                                        style={isArabic ? checkIconStyleRTL : checkIconStyle} hidden={isHidden} />
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                        <InputGroup style={inputGroup}>
                            <Input id="yourName" type="text" name="customerName" placeholder="Your Name"
                                state={this.state.customerName}
                                value={this.state.customerName}
                                onChange={this.changeState}
                                style={input}
                                className='addressInputs' />
                        </InputGroup>
                                {
                                    this.state.isSpecialSymbols ? 
                                        <div style={{width: '100%', color: 'red', textAlign: 'left', marginBottom: '10px'}}>{i18n.t('common:alerts.allowedCharacters')}</div> : null
                                }
                        <InputGroup style={inputGroup}>
                            <Input id="yourEmail" type="text" name="customerEmail" placeholder="Email"
                                state={this.state.customerEmail}
                                value={this.state.customerEmail}
                                onChange={this.changeState}
                                style={input}
                                className='addressInputs'
                                maxLength={64} />
                        </InputGroup>
                        <div
                            hidden={!this.props.customer.phoneNumberErrMsg}
                            style={{ color: 'red', textAlign: 'left', padding: '0 9px' }}
                        >{this.props.customer.phoneNumberErrMsg}</div>
                        <InputGroup style={inputGroupTickbox}>
                            <InputGroupAddon id="userCredentialsPrepender" addonType="prepend" style={{backgroundColor: menuItemsBackground, color: primaryFontColor}}>
                                <InputGroupText style={{...inputGroupText, ...{backgroundColor: menuItemsBackground}}}>
                                    <Input addon type="checkbox" name="newsletter" value={this.state.newsletter} onChange={this.changeState} />
                                </InputGroupText>
                                <Label style={label} for="newsletter">{i18n.t('screens:userCredentialsScreen.newsletterMsg')} <span onClick={() => this.openPrivacyPolicyPage()} style={Object.assign({}, privacyPolicy, {color: primaryColor, textDecoration: textDecoration})}>{i18n.t('screens:userCredentialsScreen.privacyPolicy')}</span>
                                </Label>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                    {
                        this.props.customer.captcha ?
                            <Col xs={8} md={6} style={marginAuto}>
                                <img src={`${FRONT_END_URL}/${this.props.customer.captcha.path}`} style={{ width: '100%', height: '50px', marginBottom: '10px' }} />
                                <InputGroup style={inputGroup}>
                                    <Input id="captchaCode" type="text" name="captchaCode" placeholder="Enter Code"
                                        state={this.state.captchaCode}
                                        value={this.state.captchaCode}
                                        onChange={this.changeState}
                                        style={input}
                                        className='addressInputs' />
                                </InputGroup> 
                            </Col> : null
                    }
                </Col>
                {this.renderModalFooter()}
            </div>
        );
    }

    renderModalFooter() {
        const { submitBtn, submitBtnDisabled, modalCustomSubmitBody } = this.props.styles;
        const { primaryColor, inactiveColor, buttonsFont, fontFamilyType, fontBold, fontItalic, uppercase } = this.props.customerThemes.selectedTheme;
        let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
        let isEmailInValidFormat = this.state.customerEmail.match(regex);
        const isDisabled = this.state.customerName !== '' && this.state.customerEmail !== '' && isEmailInValidFormat && this.state.captchaCode && this.state.isPhoneTyped ? false : true;
        let selectSubtmitButtonStyle, submitBtnClassName, activeInactiveBtn, submitBtnText;

        const fontWeight = fontBold === 'bold' ? fontBold : 300;
        const submitBtnFontStyle = {
            fontWeight,
            fontFamily: fontFamilyType,
            fontStyle: fontItalic,
            textTransform: uppercase
        }
        submitBtnText = i18n.t('screens:phoneNumberScreen.submit');

        if (!isDisabled) {
            selectSubtmitButtonStyle = submitBtn;
            submitBtnClassName = "submitNumber";
            activeInactiveBtn = { backgroundColor: primaryColor, color: buttonsFont };
        } else {
            selectSubtmitButtonStyle = submitBtnDisabled;
            submitBtnClassName = "";
            activeInactiveBtn = { backgroundColor: inactiveColor, color: buttonsFont };
        }

        return (
            <Row className='' style={modalCustomSubmitBody}>
                <Col xs={12} sm={10} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Col xs={12} sm={8} className="submitNumberBtn">
                        <Button disabled={isDisabled} className={submitBtnClassName} style={Object.assign({}, selectSubtmitButtonStyle, activeInactiveBtn, submitBtnFontStyle, { padding: 0, alignItems: 'center' })} onClick={() => this.registerCustomer(this.state)}>
                            {submitBtnText}
                        </Button>
                    </Col>
                </Col>
            </Row>
        );
    }
    
    render() {
       
        return (
            <React.Fragment>
                {this.renderContent()}
            </React.Fragment>
        );
    }
}